import RPC from "./rpc";
import { v4 as uuidv4 } from "uuid";
import { Loggy } from "../../loggy";


export class Request1 {

    rpc: RPC;

    args: any;

    returns: any;

    key: string;

    uuid: string;

    resolve: any;
    reject: any;

    log: Loggy

    constructor(rpc: RPC, log: Loggy) {
        this.rpc = rpc;
        this.args = [];
        this.returns = [];
        this.key = "";
        this.uuid = uuidv4();
        this.log = log;
    }

    arg(data: any): Request1 {
        this.args.push(data);
        return this;
    }


    handleResponse(data: any) {
        this.resolve(data);
    }

    call(key: string) {

        this.rpc.client.sendObject({
            key: "rpc.request",
            data: {
                uuid: this.uuid,
                path: key,
                args: this.args
            }
        });


        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
